/* eslint-disable prettier/prettier */
import './styles/cart.scss';
import './styles/cart-new.scss';
import './styles/checkout.scss';
import './styles/checkout_map.scss';
import './styles/product-item.scss';
import pathToCartMiniTemplate from './templates/cart-mini-fashion.html';
import pathToProductItem from './templates/product-item.html';
import cartCheckout from './templates/cart-checkout.html';
import cartCheckoutMap from './templates/cart-checkout-map.html';
const MODULE_NAME = 'cart';
angular.module(MODULE_NAME).config(["$provide", function ($provide) {
  $provide.decorator("cartMiniListDirective", ["$delegate", function ($delegate) {
    const directive = $delegate[0];
    directive.templateUrl = pathToCartMiniTemplate;
    return $delegate;
  }]);
}]);
angular.module(MODULE_NAME).directive('cartMobileProduct', function () {
  return {
    restrict: 'EA',
    scope: {
      productList: '=',
      isShoppingCartItem: '=',
      cartMiniCrtl: '='
    },
    controller: 'CartProductItemCtrl',
    controllerAs: 'productCart',
    bindToController: true,
    replace: true,
    templateUrl: pathToProductItem //.replace('./Templates', './Templates/Promo')
  };
});

angular.module(MODULE_NAME).directive('cartMobileCheckout', function () {
  return {
    restrict: 'EA',
    scope: {
      cartMiniCrtl: '=',
      updateShipping: '&'
    },
    controller: 'CartCheckoutCtrl',
    controllerAs: 'checkoutCart',
    bindToController: true,
    replace: true,
    templateUrl: cartCheckout //.replace('./Templates', './Templates/Promo')
  };
});

angular.module(MODULE_NAME).directive('cartMobileMapDeliveryCheckout', function () {
  return {
    restrict: 'EA',
    scope: {
      templateUrl: '=',
      pointDeliveryMapShipping: '=',
      pointDeliveryMapIsSelected: '=',
      pointDeliveryMapCallback: '&',
      pointDeliveryMapContact: '<?',
      pointDeliveryCheckoutCart: '=',
      pointDeliveryIsSelectedPoint: '='
    },
    controller: 'CartMapModalCtrl',
    controllerAs: 'checkoutMapCart',
    bindToController: true,
    replace: true,
    templateUrl: cartCheckoutMap //.replace('./Templates', './Templates/Promo')
    //template: '<div data-ng-include="checkoutCart.templateUrl"></div>',
    //templateUrl: cartCheckout.replace('./Templates', './Templates/Promo')
  };
});

import cartCheckoutService from './services/cartCheckoutService.js';
import './controllers/cartMiniCustomController.js';
import './controllers/cartProductItemController.js';
import './controllers/cartCheckoutController.js';
import './controllers/cartMapModalController.js';
angular.module(MODULE_NAME).service('cartCheckoutService', cartCheckoutService);
export default MODULE_NAME;